import type { FC } from 'react';

/**
 * Props for WizardStepIndicator component.
 */
export interface WizardStepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepTitle: string;
}

/**
 * WizardStepIndicator - Displays "Step X of Y - Title" text
 *
 * Uses text-chariot-text-primary for theme-aware coloring:
 * - Dark mode: white text
 * - Light mode: chariot black text
 *
 * Replaces hardcoded text-purple-400 which failed WCAG AA in light mode.
 */
export const WizardStepIndicator: FC<WizardStepIndicatorProps> = ({
  currentStep,
  totalSteps,
  stepTitle,
}) => (
  <span className="text-chariot-text-primary text-sm font-bold">
    Step {currentStep} of {totalSteps} - {stepTitle}
  </span>
);
